import { render } from "./Asiento_AsientoDet.vue?vue&type=template&id=0ff9d636"
import script from "./Asiento_AsientoDet.vue?vue&type=script&lang=js"
export * from "./Asiento_AsientoDet.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__